import { z } from 'my-zod'
import { addOnProductSystemView } from './add-on-product-system-view'

export const merchandiseAddOnProduct = addOnProductSystemView
  .pick({
    id: true,
    shortId: true,
    versionId: true,
    outfitterId: true,
    imageUrl: true,
    price: true,
    priceUnit: true,
    title: true,
    overview: true,
    taxPolicyIds: true,
    createdDate: true,
    lastModifiedDate: true,
    deletedDate: true
  })
  .augment({
    title: z
      .string()
      .min(1, 'Required')
      .refine((val) => !!val.trim(), 'Required'),
    price: z.number().min(0, 'Required'),
    overview: z.string().min(1, 'Required'),
    category: z.string().optional(),
    type: z.literal('Merchandise')
  })

export type merchandiseAddOnProduct = z.infer<typeof merchandiseAddOnProduct>
